<template>
  <div>
    <div ref="output"></div>
  </div>
</template>

<script>

export default {
  name: 'report-viewer',
  props: {
    template: {
      type: Object,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      viewer: null,
    }
  },
  methods: {
    addToobarButtons(viewer) {
      const userButton = viewer.jsObject.SmallButton("userButton", "Schließen", "emptyImage");
      userButton.action = function () { history.back() }

      const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
      const buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
      const userButtonCell = buttonsTable.rows[0].insertCell(0);
      userButtonCell.className = "stiJsViewerClearAllStyles";
      userButtonCell.appendChild(userButton);
    },
    getViewrOptions() {
      const options = new window.Stimulsoft.Viewer.StiViewerOptions();
      options.toolbar.visible = true;
      options.toolbar.showOpenButton = false;
      options.toolbar.showSaveButton = false;
      options.toolbar.showSaveButton = false;

      return options;
    },
    setLicence() {
      window.Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlOyCQxQBY909euw/s/aD6faVBj7cblZ3F1ee5fNNShe8QFq6" +
        "LgfXLVBunVwS169gYLQLH7SdSt9iqg/pdRxh8PCnIDljkSAoJl0s1ozcwZ7ljBAb0XI/8DZhvcPvyiRt484SFNF/vQ" +
        "+Nap5B1vHVfR1NlG/A+HauTVVOTa2uW1Rd4TBsz8aw/JzajtO32Rcz01pzzW7qkXOwXLpIsh6B1RpABuCA9yjExd1N" +
        "EA7XXDZf7mogGg1MSomPgwiKp1fkeu//gf+yG4rYwbDTDKFT8uuJLCIba8ZdGA67lWTAMWCcSgVaREXv/jMxeuHWyi" +
        "U4rHFl6kfkmG9mbciRiZ7L+AlWkFnTkMh2aEJM03oIxVqonpRqwmIgdr2IqxxFFp0QOoxQ0PcOUG918XwiA0ggJUMX" +
        "6Bt/YT+fvp80T6egldffMeoLjGxZXGhn37GDs0oyWj5ldoha0Z9AUf2nvfjYsGRehvPNJMrVrkWnw2qDGQU/5l/xB1" +
        "JDPVYQNH231UeJHuT7jYAoGnx7Af5irUlUmp";

    }
  },
  async mounted() {
    this.setLicence();
    const viewer = new window.Stimulsoft.Viewer.StiViewer(this.getViewrOptions(), 'StiViewer', false)
    const report = new window.Stimulsoft.Report.StiReport();
    report.load(this.template.design);


    const json = this.$props.data
      ? JSON.stringify(this.$props.data)
      : {"Info":{"slaughterHouse":"Jöbstl Bauerngut GmbH","street":"Straße 1","town":"Hausmannstätten","postalCode":"8071","uid":"todo","invoiceDate":"2023-06-13T12:01:19.2818657+02:00","invoiceNumber":"Ungültig","printDate":"2023-06-13T00:00:00+02:00","footer":"Footer"},"Lieferungen":[{"name":"GALLI Josefa - 3002152","pieces":231,"weight":21988.1,"costs":56954.9},{"name":"SAUER Franz - 3392899","pieces":4,"weight":350,"costs":841.57},{"name":"POELZL Christian - 3321100","pieces":24,"weight":2317.8,"costs":6015.44},{"name":"STOISER Anton - 3474852","pieces":48,"weight":4782.6,"costs":12014.4}],"Summe":{"totalDeliveryPieces":307,"totalDeliveryWeight":29438.5,"totalCosts":75826.31,"totalProductAdditionNet":77883.7786,"totalProductAdditionTax13":10124.891218,"totalProductAdditionTax20":0,"totalProductAdditionGross":88008.669818,"totalOtherAdditionNet":0,"totalOtherAdditionTax13":0,"totalOtherAdditionTax20":0,"totalOtherAdditionGross":0,"totalAdditionNet":0,"totalAdditionTax13":0,"totalAdditionTax20":0,"totalAdditionGross":0,"additionDiscount":440.04,"total":87568.629818},"Produkt_ZuAbschlaege":[{"name":"Warenwert","quantity":307,"price":0,"net":75826.31,"tax13":9857.4203,"tax20":0,"gross":85683.7303},{"name":"AMA Marketingzuschlag","quantity":307,"price":-0.75,"net":-230.25,"tax13":-29.9325,"tax20":0,"gross":-260.1825},{"name":"Styriabrid Börsenprämie","quantity":29438.5,"price":0.018,"net":529.893,"tax13":68.88609,"tax20":0,"gross":598.77909},{"name":"Mengenzuschlag","quantity":231,"price":3,"net":693,"tax13":90.09,"tax20":0,"gross":783.09},{"name":"Mengenzuschlag","quantity":24,"price":0.28,"net":6.72,"tax13":0.8736,"tax20":0,"gross":7.5936},{"name":"Mengenzuschlag","quantity":48,"price":1.96,"net":94.08,"tax13":12.2304,"tax20":0,"gross":106.3104},{"name":"Anteilige Klassifizierungskosten","quantity":307,"price":-0.35,"net":-107.45,"tax13":-13.9685,"tax20":0,"gross":-121.4185},{"name":"Qualitätszuschlag Optimalgewicht","quantity":9225,"price":0.02,"net":184.5,"tax13":23.985,"tax20":0,"gross":208.485},{"name":"Qualitätszuschlag Steirerglück","quantity":18667.7,"price":0.03,"net":560.031,"tax13":72.80403,"tax20":0,"gross":632.83503},{"name":"Styriabrid Ausgleichsprämie","quantity":29438.5,"price":0.0076,"net":223.7326,"tax13":29.085238,"tax20":0,"gross":252.817838},{"name":"Erzeugeranlieferungsprämie","quantity":350,"price":0.03,"net":10.5,"tax13":1.365,"tax20":0,"gross":11.865},{"name":"Styriabrid Anlieferung","quantity":2317.8,"price":0.04,"net":92.712,"tax13":12.05256,"tax20":0,"gross":104.76456}],"Sonst_ZuAbschlaege":null,"Gewicht":[{"name":"Optimalgewicht","share":59.93485342019544,"pieces":184,"weight":17758.8,"weightAvg":96.51521739130435,"mfaAvg":61.05434782608695},{"name":"Normalgewicht","share":28.01302931596091,"pieces":86,"weight":8204,"weightAvg":95.3953488372093,"mfaAvg":60.63953488372093},{"name":"Übergewicht","share":6.188925081433225,"pieces":19,"weight":2073.7,"weightAvg":109.1421052631579,"mfaAvg":61.1578947368421},{"name":"Untergewicht","share":5.863192182410423,"pieces":18,"weight":1402,"weightAvg":77.88888888888889,"mfaAvg":62.22222222222222}],"Handelsklasse":[{"name":"S","share":78.50162866449512,"pieces":241,"weight":23072.1,"weightAvg":95.73485477178423,"mfaAvg":61.912863070539416},{"name":"E","share":20.521172638436482,"pieces":63,"weight":6060.3,"weightAvg":96.1952380952381,"mfaAvg":57.92063492063492},{"name":"U","share":0.9771986970684039,"pieces":3,"weight":306.1,"weightAvg":102.03333333333333,"mfaAvg":53.666666666666664},{"name":"sonst","share":0,"pieces":0,"weight":0,"weightAvg":0,"mfaAvg":0}]};
    const dataSet = new window.Stimulsoft.System.Data.DataSet("Data");
    dataSet.readJson(json);
    for(let ds of dataSet.tables.list) {
      ds.tableName = ds.tableName.replace('root_', '');
    }
    report.dictionary.databases.clear();
    report.regData("Data", "Data", dataSet);
    viewer.report = report;
    viewer.renderHtml(this.$refs.output);
    this.addToobarButtons(viewer);
  }
}
</script>

<style scoped>

</style>
